import { Controller } from 'stimulus';
import gsap from 'gsap';

class WordSplitController extends Controller {
  trigger() {
    gsap.fromTo(this.partTargets, {
      y: -5,
    }, {
      y: 0,
      opacity: 1,
      stagger: 0.25,
      duration: 1.25,
      delay: this.delay(),
    });
  }

  delay() {
    return this.element.getAttribute('data-delay')
      ? parseFloat(this.element.getAttribute('data-delay'))
      : 0;
  }
}

WordSplitController.targets = [
  'part',
];

export default WordSplitController;
